// extracted by mini-css-extract-plugin
module.exports = {"mainmiddle":"ArticleLayout_mainmiddle__FaCa3"};